export const PREVIEW_WINDOW_LABEL = '_storyblok_tk';
